import { render, staticRenderFns } from "./addPhoto.vue?vue&type=template&id=24f6905e"
import script from "./addPhoto.vue?vue&type=script&lang=js"
export * from "./addPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports